import React from "react";
import Button from "../Button";
//TODO 动态权限

function getLocalUserPermissions() {
  //TODO 优化用户权限逻辑
  let s = sessionStorage.getItem("userInfo") || localStorage.getItem("userInfo");
  if (s) {
    try {
      return JSON.parse(s).permissions;
    } catch (e) {
      return [];
    }
  } else {
    return [];
  }
}
export const AuthButton = (getUserPermissions = getLocalUserPermissions) => {
  return (props) => {
    if (!props.active) return null;
    const allAuth = getUserPermissions();
    const { auth } = props;
    if (auth && !allAuth.includes(auth)) return null;
    return <Button {...props} />;
  };
};
